import { SettingsContext } from '../context/SettingsContext';
import getGeneralSettings from '@spa/lib/settings/readers/getGeneralSettings';
import { useContext } from 'react';

const useGeneralSettings = (): ReturnType<typeof getGeneralSettings> =>
  getGeneralSettings(useContext(SettingsContext));
export default useGeneralSettings;
